export const NotificationViewStatus = {
    SEEN: 'SEEN',
    UNSEEN: 'UNSEEN',
}

export const RateTypes = {
    FLAT_ORDER: 'FLAT_ORDER',
    FLAT_ITEM: 'FLAT_ITEM',
    PERCENT_REVENUE: 'PERCENT_REVENUE'
}